// @flow

/*
 ** Imports
 */

// Modules
import React from 'react';
import styled from 'styled-components';

// Framework
import Api from 'src/methods/api';
import Callstack from 'src/methods/api/callstack';

// Foundation
import { __ } from 'src/methods/l10n';

/*
 ** Types
 */

type ParentPropTypes = {
  className?: string,
  children: any,
  type?: string,
  name?: string
};

type StateTypes = {
  hasError: boolean
};

type PropTypes = ParentPropTypes;

/**
 * Styled
 */
const ErrorRoot: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  color: #fff;
`;

/**
 * Component
 */
class ErrorBoundary extends React.Component<PropTypes, StateTypes> {
  constructor(props: PropTypes) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(e: Error) {
    const { className, type, name } = this.props;

    Api.warn(
      'React boundary error',
      {
        className,
        type,
        name,
        error: Callstack.parseError(e)
      },
      true
    );
  }

  render() {
    if (this.state.hasError) {
      return <ErrorRoot className={this.props.className}>{__('An error has occurred...')}</ErrorRoot>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
